import React, { useContext, useState } from 'react';
import MainAppContext from '../../../../MainAppContext';

import { t } from 'i18next';
import {Row, Col} from "react-bootstrap";
import Sticky from 'react-sticky-el';
import { ActionButton, CommandBarButton, DirectionalHint, IconButton, OverflowSet, TooltipHost } from '@fluentui/react';

import UserActions from '../UserActions';
import QuickActions from '../QuickActions';
import SearchBox from '../SearchBox';

import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { getReportCommunications, getReportListBooksMilestones, getReportListBooksSectionParty, getReportListUserBooksSectionParty, getReportPendingCommunications, getReportSiteUse } from '../../../../services/sBook/report.service';
import { getReportBoardScopeConfig, getReportBoardScopeValues, getReportContractKpiRoles, getReportContracts, getReportGapAnalyzeActions, getReportGapAnalyzeComments, getReportGapRevisionActions, getReportSiteEdps, getReportSiteKpiActions, getReportSiteKpiConfigurations, getReportSiteKpis } from '../../../../services/sKPI/report.service.js';
import { generateSkh } from '../../../../services/Auth/user.service';
import { download, getLocalClientTimeZone, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, setHelpConfig, showMessage } from '../../../../common/Helpers';
import { __BoardIdTemplateStatic, __enum_SystemPages, __MessageTypes, __ReportTypes, __SystemPagesPaths, enum__BOARD_TEMPLATE_TYPE, enum__Clients, enum__PRIVILEGE_APP, enum__SITE_MENU_TYPE_MAIN, enum__SITE_MENU_TYPE_QUICK } from '../../../../common/Dictionaries.js';
import Message from '../../../Common/Message/MessageBox.js';

import logo from '../../../../images/sg3plus.png';

import '../../../../styles/css/style.css';
import '../../../../styles/css/style-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { __onGoToBoardCartera, __onGoToBoardContract, __onGoToBoardEP, __onGoToBoardHome, __onGoToBoardKpiOperational, __onGoToBoardKpiConsolidated, __onGoToConfigureBoard, __onGoToGapV2, __onGoToMaintainer, __onGoToManageElement, __onGoToReport, __onGoToRoles, __onGoToIntegrationFG, __onGoToBoardHomeCurrentTab, __onGoToConfigPartiesEP, __onGoToContractualModifications, __onGoToAMSAReport, __onGoToCreateBook, __onGoToBook, __onGoToBookLanding, __onGoToPowerBI, __onGoToObligationControl, __onGoToElementObligationAchives } from '../../../../common/SystemRedirections';
import { sowIntegration_KPI } from '../../../../common/Helpers/SAPFG_Integration.js';
import { useGetClientSubMenu } from './useOfSubMenu.js';
import NotificationAlert from '../NotificationAlert/index.js';
import { action_setBoardViewElementId } from '../../../../reducers/actions/KPI/actions.js';
import { getAdminTaskMonitoringKpiExport } from '../../../../services/sKPI/board.service.js';
import { getHomeContractObligationAchievesExport, getObligationAchieveElementExport } from '../../../../services/sCO/obligationElement.service.js';

import { useBlocking } from "../../../../pages/BlockingProvider.js";
import Loading from '../Loading/index.js';
import { authGetClient } from '../../../../actions/auth-action.js';
import moment from 'moment';


function getSiteTitle(pageDictionary, locationSearch) {
    try {
        const manipulatedUrl = window.location.href.replace(/^(?:\/\/|[^/]+)*\//, '').replace(locationSearch, '').replace(/\/\d+.*/g, "").toLowerCase()
        const title = manipulatedUrl !== "" ?
            (pageDictionary.find(x => manipulatedUrl === (x.key2.toLowerCase())).siteName !== '' ? t(pageDictionary.find(x => manipulatedUrl === (x.key2.toLowerCase())).siteName) + " - " : '') + t(pageDictionary.find(x => manipulatedUrl === (x.key2.toLowerCase())).value)
            :
            t('data-lang-pagename-home');   
        
        return title;
    } catch (error) {
        return t('data-lang-pagename-notfound');
    }

}

function Menu(props) {
    const contextSite = useContext(MainAppContext);
    const blocking = useBlocking();


    const location = useLocation()
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { token: currentAuth } = useSelector((state) => state.auth);

    const { _elementId: elementId } = useSelector((state) => state.boardViewScope);
    const { _elementListIds: elementListIds } = useSelector((state) => state.portfolioScope);


    const queryStringBoardTypeId = (window.location.pathname.endsWith("/4") && window.location.pathname.toLowerCase().startsWith('/board/')) ?
    enum__BOARD_TEMPLATE_TYPE.OPERATIONAL : ((window.location.pathname.endsWith("/5") && window.location.pathname.toLowerCase().startsWith('/board/')) ? enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED : "") ;

    const queryStringGapElementId = (window.location.pathname.toLowerCase().startsWith('/kpi/gapv2/')) ? window.location.pathname.toLowerCase().split('/kpi/gapv2/')[1] : null;
    const queryStringObligationElementId = (window.location.pathname.toLowerCase().startsWith('/elementobligations/')) ? window.location.pathname.toLowerCase().split('/elementobligations/')[1].split('/')[0] : null;
    const aux_elementId = queryStringGapElementId !== null ? queryStringGapElementId : (queryStringObligationElementId !== null ? queryStringObligationElementId : (!isNullUndefinedOrEmpty(elementId) ? elementId : 0));

    const widthScrollYToChangeStyle = 80;
    const exportApplicationOptions = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
    const aux_pageTitle = getSiteTitle(__SystemPagesPaths, location.search);
    const pageTitle = aux_pageTitle === t('data-lang-pagename-bookcreation') ? (window.location.pathname.split('/').length > 2 ? t('data-lang-pagename-book') : aux_pageTitle) : aux_pageTitle;
    
    const profileHasAdminitrationMenuAccess = contextSite.onlyObserver || (contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin)

    const noOp = () => undefined;

    const [clientSubMenuItems, setClientSubMenuItems] = useState(null);
    useGetClientSubMenu(clientSubMenuItems, setClientSubMenuItems);

    const [navbar, setNavBar] = useState(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const changeBackground = () => {
        if (window.scrollY >= widthScrollYToChangeStyle) {
            setNavBar(true);
        }
        else {
            setNavBar(false);
        }
    }

    const onGoHomeProduct = () => {
        const currentUrl = window.location.href.toLowerCase();
        let isKpiHome = currentUrl.indexOf('/board/') !== -1  || currentUrl.indexOf('/kpi/') !== -1  || (currentUrl.indexOf('/business/') !== -1 || currentUrl.indexOf('/kpihomev2') !== -1);
        let isBookHome = currentUrl.indexOf('/book/') !== -1 || currentUrl.indexOf('/bookhome') !== -1;

        dispatch(action_setBoardViewElementId(null));
        
        if (isKpiHome) {
            __onGoToBoardHomeCurrentTab()
        }
        else {
            window.location.href = (isKpiHome ? __SystemPagesPaths[__enum_SystemPages.BoardLanding].text : (isBookHome ? __SystemPagesPaths[__enum_SystemPages.HomeBook].text : '/'));
            /*history.push({
                pathname: (isKpiHome ? __SystemPagesPaths[__enum_SystemPages.BoardLanding].text : (isBookHome ? __SystemPagesPaths[__enum_SystemPages.HomeBook].text : '/')),
            })*/
        }
    }

    const onGoHome = () => {
        window.location.href = "/"
    }

    const onGoToBulkUploadClick = () => {
        if (!isNullUndefinedOrEmpty(aux_elementId) && aux_elementId !== 0) {
            history.push({
                pathname: `${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/${ aux_elementId }`
            })
        }
        else {
            if (queryStringGapElementId !== null) {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}/${ queryStringGapElementId }`
                })
            }
            else {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BulkUpload].text}`
                })
            }
        }
        

    }

    const onGoToSG3LegacyClick = () => {
        generateSkh(contextSite.username).then((response) => {
            if (response.data.succeeded) { 
                window.location.href = `${contextSite.sg3LegacyPath}?skh=${ response.data.data }`;
            } else {
                window.location.href = `/`;
            }
        },
        (error) => {
        }).catch(() => {
        }); 
    }

    const onExecuteReportClick = (reportType, exportFileName) => {
        blocking.start(<Loading inputParam_Style={{marginLeft: '-45px'}} inputParam_ShowLoading={true} inputParam_Text={t('data-lang-lbl-executing')} />);

        const linkExport = document.getElementById("linkExport");
        const defaultExportFileName = t('data-lang-export-file-name');
        const timeOffset = getLocalClientTimeZone()
        const periodStartDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate;
        const periodEndsDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate;

        switch (reportType) {
            case __ReportTypes.BK_MILESTONES:
                getReportListBooksMilestones(0).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.BK_BOOKPARTYS:
                getReportListBooksSectionParty().then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.MAIN_SITEUSE:
                getReportSiteUse(timeOffset).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.BK_BOOKUSERS:
                getReportListUserBooksSectionParty().then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.BK_COMMUNICATIONS:
                getReportCommunications(timeOffset).then((response) => {
                    if (response.data.data !== null) {
                        download(response.data.data.fileBytes, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(response.data.message));
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.BK_PENDINGCOMMUNICATIONS:
                getReportPendingCommunications(0, timeOffset).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.KPI_SITEKPIS:
                getReportSiteKpis(timeOffset, aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            case __ReportTypes.KPI_SITEKPICONFIGURATIONS:
                getReportSiteKpiConfigurations(timeOffset, aux_elementId).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.KPI_SITEKPIACTIONS:
                getReportSiteKpiActions(timeOffset, aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.KPI_CONTRACTROLES:
                getReportContractKpiRoles(timeOffset, aux_elementId).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
           
            case __ReportTypes.KPI_GAPREVSITIONACTIONS:
                getReportGapRevisionActions(timeOffset, aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.KPI_GAPANALYZEACTIONS:
                getReportGapAnalyzeActions(timeOffset, aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.KPI_GAPANALYZECOMMENTS:
                getReportGapAnalyzeComments(timeOffset, aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                },
                (error) => {
                }).catch((ex) => {
                });
                break;
            case __ReportTypes.KPI_ADMINISTRATIVETASKS:
                const calendarSelector = contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId;
                getAdminTaskMonitoringKpiExport(aux_elementId, calendarSelector, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;

            case __ReportTypes.EDP_CONTRACTS:
                getReportContracts(timeOffset).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.EDP_CONFIGCONSOLIDATEDGROUP:
                getReportBoardScopeConfig(aux_elementId, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.EDP_RESULTCONSOLIDATEDGROUP:
                getReportBoardScopeValues(
                    aux_elementId,
                    contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                    contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                    periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.EDP_SITEEDPS:
                getReportSiteEdps(timeOffset, aux_elementId, null, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.CO_SITEOBLIGATIONS:
                getHomeContractObligationAchievesExport(aux_elementId).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            case __ReportTypes.CO_SITEOBLIGATIONACHIEVEMENTS:
                getObligationAchieveElementExport(aux_elementId).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            default:
                break;
        }
    }

    const onExecuteReportClickElementIdList = (reportType, exportFileName, communicationOpen = true) => {
        blocking.start(<Loading inputParam_Style={{marginLeft: '-45px'}} inputParam_ShowLoading={true} inputParam_Text={t('data-lang-lbl-executing')} />);

        const linkExport = document.getElementById("linkExport");
        const defaultExportFileName = t('data-lang-export-file-name');
        const timeOffset = getLocalClientTimeZone()
        const periodStartDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate;
        const periodEndsDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate;
        const aux_elementId_list = !isNullUndefinedOrEmptyOrZero(aux_elementId) && aux_elementId.length > 0 ? [aux_elementId] : elementListIds;

        switch (reportType) {
            case __ReportTypes.BK_MILESTONES:
                const itemToSend = {
                    timeOffset: 0,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportListBooksMilestones(itemToSend, 0).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            case __ReportTypes.BK_BOOKPARTYS: {
                const itemToSend = {
                    timeOffset: 0,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportListBooksSectionParty(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.MAIN_SITEUSE: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportSiteUse(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.BK_BOOKUSERS: {
                const itemToSend = {
                    timeOffset: 0,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportListUserBooksSectionParty(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.BK_COMMUNICATIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportCommunications(itemToSend, communicationOpen).then((response) => {
                    if (response.data.data !== null) {
                        download(response.data.data.fileBytes, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(response.data.message));
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            }
            case __ReportTypes.BK_PENDINGCOMMUNICATIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                getReportPendingCommunications(itemToSend, 0).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_SITEKPIS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportSiteKpis(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            } 
            case __ReportTypes.KPI_SITEKPICONFIGURATIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
            
                getReportSiteKpiConfigurations(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_SITEKPIACTIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportSiteKpiActions(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_CONTRACTROLES: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }

                getReportContractKpiRoles(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_GAPREVSITIONACTIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportGapRevisionActions(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_GAPANALYZEACTIONS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportGapAnalyzeActions(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_GAPANALYZECOMMENTS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportGapAnalyzeComments(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.KPI_ADMINISTRATIVETASKS: {
                const calendarSelector = contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId;
                getAdminTaskMonitoringKpiExport(aux_elementId, calendarSelector, periodStartDate, periodEndsDate).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.EDP_CONTRACTS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }

                getReportContracts(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.EDP_CONFIGCONSOLIDATEDGROUP: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportBoardScopeConfig(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.EDP_RESULTCONSOLIDATEDGROUP: {
                //Entendería que display_aggregation_id no se usa.
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                    display_aggregation_id: contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
                    l_elements: aux_elementId_list,
                    dt_ini: moment(periodStartDate).format('MM/DD/YYYY'),
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportBoardScopeValues(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.EDP_SITEEDPS: {
                const itemToSend = {
                    timeOffset: timeOffset,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: moment(periodEndsDate).format('MM/DD/YYYY'),
                }

                getReportSiteEdps(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break;
            }
            case __ReportTypes.CO_SITEOBLIGATIONS: {
                const itemToSend = {
                    timeOffset: 0,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }

                getHomeContractObligationAchievesExport(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            }
            case __ReportTypes.CO_SITEOBLIGATIONACHIEVEMENTS: {
                const itemToSend = {
                    timeOffset: 0,
                    calendar_selector_id: 0,
                    display_aggregation_id: 0,
                    l_elements: aux_elementId_list,
                    dt_ini: null,
                    dt_fin: null,
                }
                
                getObligationAchieveElementExport(itemToSend).then((response) => {
                    if (response.data !== null) { 
                        download(response.data, exportApplicationOptions, linkExport, exportFileName, defaultExportFileName);
                    } else {
                        //##Mensaje de exito.
                    }
                    blocking.stop();
                },
                (error) => {
                    blocking.stop();
                }).catch((ex) => {
                    blocking.stop();
                });
                break; 
            }
            default:
                break;
        }
    }
    
    const onHelp = () => {
        contextSite.help.setter(!contextSite.help.value);
        setHelpConfig()
    }

    const onGoToManuals = () => {
        window.location.href = '/DocumentTeach'
    }

    const onRenderItem = (item) => {
        if (item.onRender) {
            return item.onRender(item);
        }
        return <CommandBarButton iconProps={{ iconName: item.icon }} onClick={item.onClick} menuProps={item.subMenuProps} text={item.name} />;
    }

    const onRenderMenuItem = (text, onClickFunction) => 
    {
        return <button onClick={onClickFunction} className="ms-ContextualMenu-link root-custom border-bottom" role="menuitem">
            <div className="ms-ContextualMenu-linkContent linkContent-custom">
                <span className="ms-ContextualMenu-itemText label-custom">{text}</span>
            </div>
        </button>;
    }

    const onRenderHelpMenuButton = () => 
    {
        return  <ActionButton styles={{icon: {color: contextSite.help.value ? "#106ebe !important" : "#fff !important"}}} iconProps={{ iconName: 'UnknownSolid' }} onClick={onHelp}>
                    {t('data-lang-menu-help')}
                </ActionButton>;
    }

    const onRenderManualMenuButton = () => 
    {
        return  <ActionButton styles={{icon: {color: "#fff !important"}}} iconProps={{ iconName: 'DocLibrary' }} onClick={onGoToManuals}>
                    {t('data-lang-menu-manuals')}
                </ActionButton>;
    }

    const manageRolesMenuVisibility = () => {
        const pageValidList = ['/business/', '/kpi/', '/board/']

        for (let index = 0; index < pageValidList.length; index++) {
            if (window.location.href.toLowerCase().indexOf(pageValidList[index].toLowerCase()) !== -1) {
                return true;
            }
        }
        return false;
    }

    const menuItems = [
        {
            key: 'home',
            name: `${t('data-lang-menu-home')} ${
                window.location.href.indexOf('/Kpi/') !== -1  || (window.location.href.indexOf('/BoardHome') !== -1 || window.location.href.indexOf('/KPIHomeV2') !== -1) ? 'KPI' :
                (window.location.href.indexOf('/Book/') !== -1 || window.location.href.indexOf('/BookHome') !== -1 ? "Book" : "")
            }`,
            icon: 'Home',
            onClick: onGoHomeProduct,
        },
        {
            key: 'sg3legacy',
            name: t('data-lang-menu-sg3legacy'),
            icon: 'AppIconDefault',
            onClick: onGoToSG3LegacyClick,
        },
        {
            key: 'reports',
            name: t('data-lang-menu-reports'),
            icon: 'ReportLibrary',
            onClick: noOp,
            subMenuProps: {
                items: [
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
                        key: 'bookreports',
                        name: t('data-lang-menu-book'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { key: 'booksectionparties', onRender: () => onRenderMenuItem(t('data-lang-menu-report-booksectionparties'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_BOOKPARTYS, `SG3Plus - ${t('data-lang-menu-report-booksectionparties')}`)) },
                                { key: 'siteuse', onRender: () => onRenderMenuItem(t('data-lang-menu-report-siteuse'), () => onExecuteReportClickElementIdList(__ReportTypes.MAIN_SITEUSE, t('data-lang-menu-report-siteuse'))) },
                                { key: 'usersbookssectionsparties', onRender: () => onRenderMenuItem(t('data-lang-menu-report-usersbookssectionsparties'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_BOOKUSERS, `SG3Plus - ${t('data-lang-menu-report-usersbookssectionsparties')}`)) },
                                { key: 'comunnicationsopen', onRender: () => onRenderMenuItem(t('data-lang-menu-report-comunnications-open'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_COMMUNICATIONS, `SG3Plus - ${t('data-lang-menu-report-comunnications')}`, true)) },
                                { key: 'comunnicationsclosed', onRender: () => onRenderMenuItem(t('data-lang-menu-report-comunnications-closed'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_COMMUNICATIONS, `SG3Plus - ${t('data-lang-menu-report-comunnications')}`, false)) },
                                { key: 'pendingcomunnications', onRender: () => onRenderMenuItem(t('data-lang-menu-report-pendingcomunnications'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_PENDINGCOMMUNICATIONS, `SG3Plus - ${t('data-lang-menu-report-pendingcomunnications')}`)) },
                                { key: 'booksmilestones', onRender: () => onRenderMenuItem(t('data-lang-menu-report-booksmilestones'), () => onExecuteReportClickElementIdList(__ReportTypes.BK_MILESTONES, `SG3Plus - ${t('data-lang-menu-report-booksmilestones')}`)) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
                        key: 'kpireports',
                        name: t('data-lang-menu-kpi'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { key: 'sitekpis', onRender: () => onRenderMenuItem(t('data-lang-menu-report-sitekpis'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_SITEKPIS, `SG3Plus - ${t('data-lang-menu-report-sitekpis')}`)) },
                                { key: 'sitekpiconfigurations', onRender: () => onRenderMenuItem(t('data-lang-menu-report-sitekpiconfigurations'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_SITEKPICONFIGURATIONS, `SG3Plus - ${t('data-lang-menu-report-sitekpiconfigurations')}`)) },
                                { key: 'sitekpiactions', onRender: () => onRenderMenuItem(t('data-lang-menu-report-sitekpiactions'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_SITEKPIACTIONS, `SG3Plus - ${t('data-lang-menu-report-sitekpiactions')}`)) },
                                { key: 'contractkpiroles', onRender: () => onRenderMenuItem(t('data-lang-menu-report-contractkpiroles'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_CONTRACTROLES, `SG3Plus - ${t('data-lang-menu-report-contractkpiroles')}`)) },
                                { key: 'administrative-tasks', onRender: () => onRenderMenuItem(t('data-lang-menu-report-administrativetask'), () => onExecuteReportClick(__ReportTypes.KPI_ADMINISTRATIVETASKS, `SG3Plus - ${t('data-lang-menu-report-administrativetask')}`)) },
                                
                                { key: 'gapanalyze-revisionactions', onRender: () => onRenderMenuItem(t('data-lang-menu-report-gaprevisionactions'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_GAPREVSITIONACTIONS, `SG3Plus ${t('data-lang-menu-report-gaprevisionactions')}`)) },
                                { key: 'gapanalyze-actions', onRender: () => onRenderMenuItem(t('data-lang-menu-report-gapanalyzeactions'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_GAPANALYZEACTIONS, `SG3Plus - ${t('data-lang-menu-report-gapanalyzeactions')}`)) },
                                { key: 'gapanalyze-comments', onRender: () => onRenderMenuItem(t('data-lang-menu-report-gapanalyzecomments'), () => onExecuteReportClickElementIdList(__ReportTypes.KPI_GAPANALYZECOMMENTS, `SG3Plus - ${t('data-lang-menu-report-gapanalyzecomments')}`)) },
                            ].filter(x => (window.location.pathname.toLowerCase().startsWith('/kpi/gapv2/') ? true : !x.key.startsWith('gapanalyze-')))
                             .filter(x => (window.location.pathname.toLowerCase().startsWith('/business/') || window.location.pathname.toLowerCase().startsWith('/board/') ? true : !x.key.startsWith('administrative-'))),
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.BASE,
                        key: 'contractreports',
                        name: t('data-lang-menu-report-edpcontract'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'edpcontracts', onRender: () => onRenderMenuItem(t('data-lang-menu-report-edpcontracts'), () => onExecuteReportClickElementIdList(__ReportTypes.EDP_CONTRACTS, `SG3Plus - ${t('data-lang-menu-report-edpcontracts')}`)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.KPI, key: 'edpconfigconsolidatedgroups', onRender: () => onRenderMenuItem(t('data-lang-menu-report-edpconfigconsolidatedgroups'), () => onExecuteReportClickElementIdList(__ReportTypes.EDP_CONFIGCONSOLIDATEDGROUP, `SG3Plus - ${t('data-lang-menu-report-edpconfigconsolidatedgroups')}`)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.KPI, key: 'edpresultconsolidatedgroups', onRender: () => onRenderMenuItem(t('data-lang-menu-report-edpresultconsolidatedgroups'), () => onExecuteReportClickElementIdList(__ReportTypes.EDP_RESULTCONSOLIDATEDGROUP, `SG3Plus - ${t('data-lang-menu-report-edpresultconsolidatedgroups')}`)) },
                            ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase())),
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
                        key: 'edpreports',
                        name: t('data-lang-menu-report-edp'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { key: 'edpsiteedps', onRender: () => onRenderMenuItem(t('data-lang-menu-report-siteedp'), () => onExecuteReportClickElementIdList(__ReportTypes.EDP_SITEEDPS, `SG3Plus - ${t('data-lang-menu-report-siteedp')}`)) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
                        key: 'coreports',
                        name: t('data-lang-menu-report-co'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { key: 'coobligations', onRender: () => onRenderMenuItem(t('data-lang-menu-report-obligations'), () => onExecuteReportClickElementIdList(__ReportTypes.CO_SITEOBLIGATIONS, `SG3Plus - ${t('data-lang-menu-report-obligations')}`)) },
                                { key: 'coobligationsachievements', onRender: () => onRenderMenuItem(t('data-lang-menu-report-obligationsachievements'), () => onExecuteReportClickElementIdList(__ReportTypes.CO_SITEOBLIGATIONACHIEVEMENTS, `SG3Plus - ${t('data-lang-menu-report-obligationsachievements')}`)) },
                            ],
                        },
                    },
                ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase())),
            },
        },
        {
            key: 'maintainers',
            name: t('data-lang-menu-administration'),
            icon: 'TableLink',
            onClick: noOp,
            subMenuProps: {
                items: [
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.BASE,
                        key: 'business',
                        name: t('data-lang-menu-business'),
                        onClick: noOp,
                        subMenuProps: {
                            items: [
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK, key: 'createbook', onRender: () => onRenderMenuItem(t('data-lang-menu-createbook'), () => __onGoToCreateBook()) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.KPI, key: 'configElements', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-elementconfiguration'), () => __onGoToManageElement()) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'legalentity', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-legalentity'), () => __onGoToMaintainer("legalentity", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'businessunit', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-businessunit'), () => __onGoToMaintainer("businessunit", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'project', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-project'), () => __onGoToMaintainer("project", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'contract', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-contract'), () => __onGoToMaintainer("contract", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'contractmodification', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-contractmodification'), () => __onGoToMaintainer("contractmodification", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'jobposition', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-jobposition'), () => __onGoToMaintainer("jobposition", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'privilege', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-privilege'), () => __onGoToMaintainer("privilege", history)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'roles', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-roles'), () => __onGoToRoles(aux_elementId)) },
                                { keyTypeUniqueId: enum__PRIVILEGE_APP.BASE, key: 'bulkupload', name: t('data-lang-menu-bulkupload'), onClick: onGoToBulkUploadClick }
                            ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))
                            .filter(x => currentAuth !== null ?
                                (currentAuth.token.profile.length > 0 && (currentAuth.token.profile[0] === "sAdmin" || currentAuth.token.profile[0] === "Admin") ? true : (x.key !== 'configElements' && x.key !== 'createbook' && x.key !== 'bulkupload'))
                                 :
                                false).filter(x => (manageRolesMenuVisibility() ? true : (x.key !== 'roles'))),
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
                        key: 'siteco',
                        name: t('data-lang-menu-co'),
                        subMenuProps: {
                            items: [
                                { key: 'obligation', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-obligation'), () => __onGoToMaintainer("obligation", history)) },
                                { key: 'obligationCategory', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-obligationcategory'), () => __onGoToMaintainer("obligationcategory", history)) },
                                { key: 'obligationInconsistency', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-obligationinconsistency'), () => __onGoToMaintainer("obligationinconsistency", history)) },
                            ].filter(x => (contextSite.securityProps.isSAdmin ? true : (x.key !== 'obligationInconsistency'))), // "Incongruentes": solo Super Administrador (sAdmin)
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
                        key: 'sitekpi',
                        name: t('data-lang-menu-kpi'),
                        subMenuProps: {
                            items: [
                                { key: 'variable', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-variable'), () => __onGoToMaintainer("variable", history)) },
                                { key: 'masterkpi', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-masterkpi'), () => __onGoToMaintainer("masterkpi", history)) },
                                //{ key: 'typeof', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-typeof'), () => __onGoToMaintainer("typeof")) },
                                //{ key: 'currency', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-currency'), () => __onGoToMaintainer("currency")) },
                                { key: 'measurementunit', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-measurementunit'), () => __onGoToMaintainer("measurementunit", history)) },
                                { key: 'sapfgintegration', onRender: () => onRenderMenuItem(t('data-lang-menu-integration-sapfg'), () => __onGoToIntegrationFG()) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
                        key: 'siteparties',
                        name: t('data-lang-menu-partie'),
                        subMenuProps: {
                            items: [
                                { key: 'partietype',   onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-partietype'), () => __onGoToMaintainer("partietype", history)) },
                                { key: 'partieUnit',   onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-partieUnit'), () => __onGoToMaintainer("partieUnit", history)) },
                                { key: 'polinomytype', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-polinomytype'), () => __onGoToMaintainer("polinomytype", history)) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
                        key: 'sitepay',
                        name: t('data-lang-menu-pay'),
                        subMenuProps: {
                            items: [
                                { key: 'deduction', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-deduction'), () => __onGoToMaintainer("deduction", history)) },
                                { key: 'increment', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-increment'), () => __onGoToMaintainer("increment", history)) },
                                { key: 'checklistnotatipo', onRender: () => onRenderMenuItem('Tipos de nota checklist EdP', () => __onGoToMaintainer("checklistnotatipo", history)) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
                        key: 'sitebook',
                        name: t('data-lang-menu-book'),
                        subMenuProps: {
                            items: [
                                { key: 'distributiongroups', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-distributiongroups'), () => __onGoToMaintainer("DitributionGroups", history)) },
                                { key: 'messagetopic', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainer-messagetopic'), () => __onGoToMaintainer("messagetopic", history)) },
                            ],
                        },
                    },
                    {
                        keyTypeUniqueId: enum__PRIVILEGE_APP.BASE,
                        key: 'boards',
                        name: t('data-lang-menu-board'),
                        subMenuProps: {
                            items: [
                                { key: 'addboard', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainers-addboard'), () => __onGoToConfigureBoard("board", history)) },
                                { key: 'addreport', onRender: () => onRenderMenuItem(t('data-lang-menu-maintainers-addreport'), () => __onGoToConfigureBoard("report", history)) },
                            ],
                        },
                    }
                ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))
                 .filter(item => item.key !== 'boards')
                 .filter(x => currentAuth !== null ?
                    (currentAuth.token.profile.length > 0 && (currentAuth.token.profile[0] === "sAdmin" || currentAuth.token.profile[0] === "Admin") ? true : (x.key !== 'boards'))
                     :
                    false),
            },
        },
        {
            key: 'help',
            onRender: onRenderHelpMenuButton,
        },
        {
            key: 'manuals',
            onRender: onRenderManualMenuButton,
        },
    ].filter(x => currentAuth !== null ?
        (currentAuth.token.hasLegacyIntegration !== true ? (x.key !== 'sg3legacy') : true) &&
        (currentAuth.token.profile.length > 0 && (profileHasAdminitrationMenuAccess) ? true : (x.key !== 'maintainers')) //&&
        //(currentAuth.token.profile.length > 0 && (profileHasAdminitrationMenuAccess) ? true : (x.key !== 'reports'))
         :
        false)

    window.addEventListener('scroll', changeBackground)

    const urlActual = window.location.href.toLowerCase();
    const stringsValidos = ["/business/", "/edp", "/board/", "/GapV2/", '/ConfigureEdP', '/ContactParties', '/Report', '/elementobligations'];

    const esValido = stringsValidos.some(str => urlActual.indexOf(str.toLowerCase()) !== -1);
    const esPaginaHomeSiteLanding = window.location.pathname === '/' || window.location.pathname === '';

    const subMenuArrayQuick = [
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.BASE,
            typeId: enum__SITE_MENU_TYPE_QUICK.LANDING,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "Home"}} onClick={() => __onGoToBoardHomeCurrentTab()} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.BASE,
            typeId: enum__SITE_MENU_TYPE_QUICK.PORTFOLIO,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "FabricReportLibrary"}} onClick={() => __onGoToBoardCartera()} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
            typeId: enum__SITE_MENU_TYPE_QUICK.BOOK,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "PublishCourse"}} onClick={() => __onGoToBookLanding()} />
        },
                {
            keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
            typeId: enum__SITE_MENU_TYPE_QUICK.CO,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "Trackers"}} onClick={() => __onGoToObligationControl()} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
            typeId: enum__SITE_MENU_TYPE_QUICK.COACHIEVES,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "Trackers"}} onClick={() => __onGoToElementObligationAchives(aux_elementId, 0)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
            typeId: enum__SITE_MENU_TYPE_QUICK.EDP,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "AllCurrency"}} onClick={() => __onGoToBoardEP(aux_elementId)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
            typeId: enum__SITE_MENU_TYPE_QUICK.ITEMS,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "AllApps"}} onClick={() => __onGoToConfigPartiesEP(aux_elementId)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.BUSINESS,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "BusinessCenterLogo"}} onClick={() => __onGoToBoardContract(aux_elementId)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.OPERATIONAL,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "Financial"}} onClick={() => __onGoToBoardKpiOperational(aux_elementId, enum__BOARD_TEMPLATE_TYPE.OPERATIONAL)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.CONSOLIDATED,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "CRMReport"}} onClick={() => __onGoToBoardKpiConsolidated(aux_elementId, enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.GAP,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "NewsSearch"}} onClick={() => __onGoToGapV2(aux_elementId)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.MULTI,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "ReportDocument"}} onClick={() => __onGoToReport(aux_elementId)} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            typeId: enum__SITE_MENU_TYPE_QUICK.POWERBI,
            menuCategory: 'quick',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "PowerBILogo"}} onClick={() => __onGoToPowerBI(aux_elementId)} />
        }
    ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))

     const subMenuArrayMain = [
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
            typeId: enum__SITE_MENU_TYPE_MAIN.BOOK,
            menuCategory: 'main',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "PublishCourse"}} onClick={() => __onGoToBookLanding()} />
        },
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
            typeId: enum__SITE_MENU_TYPE_MAIN.CO,
            menuCategory: 'main',
            component: <IconButton styles={{root: {color: "white"}}} iconProps={{iconName: "Trackers"}} onClick={() => __onGoToObligationControl()} />
        }
    ].filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))
                                                            

    return (
        <>
            {
                window.location.href.toLowerCase().indexOf(__SystemPagesPaths[__enum_SystemPages.Logout].text.toLowerCase()) === -1 &&
                <>
                    <div className={"site-navbar-wrap"}>
                        <a href="/" style={{display: "none"}} id="linkExport" >#</a>
                        <div style={{position: "absolute", width: "420px", right: "16px", top: "8px", zIndex: 1000}}>
                            <Message
                                inputParam_Position='absolute'
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </div>
                        <Sticky style={{miminHeight: "88px !important"}} className={"site-navbar2 site-navbar-target js-sticky-header" + (navbar ? " active" : "")} topOffset={0}>
                            <div className="mb-1 pt-2 text-center nav-tranparent align-items-center d-flex"  >
                                <div>
                                    <div className="navbar-header ps-2 pb-3 cursor-pointer" onClick={onGoHome}>
                                        <img className='d-xs-none d-sm-block d-none d-sm-block' width={125} src={logo} alt="Logo" />
                                        <img className='d-xs-none d-sm-block d-block d-sm-none' width={90} src={logo} alt="Logo" />
                                    </div>
                                </div>
                                <div className='w-100'>
                                    <div className="ps-2 text-start d-flex" style={{padding: "0px"}}>
                                        <div>
                                            <div className="mr-auto float-start">
                                                <h3>
                                                    <a className="menu-title" href="/">{contextSite.clientName}</a>
                                                </h3>
                                            </div>
                                            <div style={{ right: 0, position: "absolute"}}>
                                                <div style={{marginTop: "-25px"}}>
                                                    <div className="py-1 pt-3">
                                                        <Row className="align-items-center d-flex pt-2">
                                                            <Col className="pe-xl-4 text-right" style={{padding: "0px"}}>
                                                                <NotificationAlert />
                                                            </Col>
                                                            <Col className="pe-xl-4 text-right" style={{padding: "0px"}}>
                                                                <div className="mr-auto float-end d-flex">
                                                                    <div className="d-sm-none d-md-none d-lg-block"><SearchBox display={false} /></div>      
                                                                    <div className="d-sm-none d-md-none d-lg-block"><QuickActions display={false} /></div>      
                                                                    <UserActions
                                                                        inputParam_Display={true}
                                                                        inputParam_PageTitle={pageTitle}
                                                                        inputParam_UserName={contextSite.username}
                                                                        inputParam_UserFullName={contextSite.securityProps.fullname}
                                                                        inputParam_Rol={t(contextSite.securityProps.perfilname)}
                                                                    />
                                                                </div>      
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ps-2 text-start d-flex site-navbar-top" style={{padding: "0px"}}>
                                        <div>
                                            <div className="pt-1 float-start">
                                                <h5>
                                                    <div className="menu-title">{ `${pageTitle} ${queryStringBoardTypeId === enum__BOARD_TEMPLATE_TYPE.OPERATIONAL ? t('data-lang-lbl-kpiboard') : (queryStringBoardTypeId === enum__BOARD_TEMPLATE_TYPE.CONSOLIDATED ? t('data-lang-lbl-kpicosolidated') : "")}` }</div>
                                                </h5>
                                            </div>
                                            <div className="d-none d-lg-flex" style={{ right: 0, position: "absolute"}}>
                                                <div>
                                                    <OverflowSet
                                                        styles={{root: { height: '35px'}, }}
                                                        className="buttom-custom"
                                                        items={
                                                            menuItems
                                                        }
                                                        onRenderItem={onRenderItem}
                                                    />
                                                    {
                                                        esValido  && subMenuArrayQuick &&
                                                        <>
                                                            {
                                                                clientSubMenuItems && clientSubMenuItems.length > 0 && subMenuArrayQuick && subMenuArrayQuick.length > 0 &&
                                                                <div className='d-flex p-0 me-2' style={{right: '0px',position: 'fixed', backgroundColor: 'gray', color: 'white'}}>
                                                                    {
                                                                        clientSubMenuItems.filter(menuItem => menuItem.menuCategory === 'quick').map((menuItem, index) => 
                                                                            <div key={index} title={t(menuItem.menuTitle)}>
                                                                                { subMenuArrayQuick.find(x => x.typeId === menuItem.menuTypeId).component }
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            }
                                                            {
                                                                clientSubMenuItems && clientSubMenuItems.length === 0 &&
                                                                <div className='d-flex p-0 me-2' style={{right: '0px',position: 'fixed', backgroundColor: 'gray', color: 'white'}}></div>
                                                            }
                                                        </>  
                                                    }
                                                    {
                                                        clientSubMenuItems && clientSubMenuItems.length > 0 && esPaginaHomeSiteLanding && subMenuArrayMain && subMenuArrayMain.length > 0 &&
                                                        <div className='d-flex p-0 me-2' style={{right: '0px',position: 'fixed', backgroundColor: 'gray', color: 'white'}}>
                                                            {
                                                                clientSubMenuItems.filter(menuItem => menuItem.menuCategory === 'main').map((menuItem, index) => 
                                                                    <div key={index} title={t(menuItem.menuTitle)} style={{display: isNullUndefined(subMenuArrayMain.find(x => x.typeId === menuItem.menuTypeId)) ? "none": 'unset'}}>
                                                                        { subMenuArrayMain.find(x => x.typeId === menuItem.menuTypeId) && subMenuArrayMain.find(x => x.typeId === menuItem.menuTypeId).component }
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="d-flex d-lg-none" style={{ right: 0, position: "absolute"}}>
                                                <OverflowSet
                                                    styles={{root: { height: '35px'}, }}
                                                    className="buttom-custom"
                                                    items={[
                                                        {
                                                            key: 'collapseMenu',
                                                            icon: 'CollapseMenu',
                                                            onClick: noOp,
                                                            subMenuProps: {
                                                                items: menuItems,
                                                            },
                                                        },
                                                    ]}
                                                    onRenderItem={onRenderItem}
                                                />
                                            </div>
                                        </div>
                                    </div>     
                                </div>                                                       
                            </div>
                        </Sticky>
                    </div>
                </>
            }
        </>
    );
}
    
export default Menu;